var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import ReactDOM from "react-dom";
import { useProvider } from "../provider/Provider.js";
import { Slot } from "../slot/Slot.js";
export const Portal = forwardRef((_a, ref) => {
    var _b, _c, _d;
    var { rootElement, asChild } = _a, rest = __rest(_a, ["rootElement", "asChild"]);
    const contextRoot = (_b = useProvider()) === null || _b === void 0 ? void 0 : _b.rootElement;
    const root = (_c = rootElement !== null && rootElement !== void 0 ? rootElement : contextRoot) !== null && _c !== void 0 ? _c : (_d = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) === null || _d === void 0 ? void 0 : _d.body;
    const Component = asChild ? Slot : "div";
    return root
        ? ReactDOM.createPortal(React.createElement(Component, Object.assign({ ref: ref, "data-aksel-portal": "" }, rest)), root)
        : null;
});
export default Portal;
//# sourceMappingURL=Portal.js.map